import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const FormGroupInput = ({ id, label, ...rest }) => (
	<Form.Group className='form-group'>
		<Form.Label htmlFor={id} className='form-label'>
			{label}
		</Form.Label>
		<Form.Control id={id} {...rest} className='form-control' />
	</Form.Group>
);

FormGroupInput.propTypes = {
	id: PropTypes.string.isRequired
};

export default FormGroupInput;
